// @flow

import gql from 'graphql-tag';

import { useQuery } from '@apollo/react-hooks';
import {
  type PaymentSource,
  type SupportedPaymentMethod,
  paymentSourceMethods,
} from '@zapier/payment';

type Input = {
  accountId: number,
};

type Output = {
  error: ?string,
  forceSourceEdit: boolean,
  isLoading: boolean,
  paymentSources: Array<PaymentSource>,
  primarySource: ?PaymentSource,
  supportedPaymentMethods: Array<SupportedPaymentMethod>,
};

export const paymentMethodsQuery = gql`
  query paymentMethodsQuery($id: Int!) {
    account(id: $id) {
      id
      paymentSources {
        details {
          ... on PaymentSourceCard {
            addressCountry
          }
        }
        id
        method
      }
      supportedPaymentMethodsv2 {
        method
        paymentProcessor
      }
    }
  }
`;

const usePaymentSource = ({ accountId }: Input): Output => {
  const queryResults = useQuery(paymentMethodsQuery, {
    skip: !accountId,
    variables: {
      id: accountId,
    },
  });

  const paymentSources = queryResults?.data?.account?.paymentSources ?? [];
  const primarySource = paymentSources[0];
  const forceSourceEdit = Boolean(
    primarySource &&
      primarySource.method === paymentSourceMethods.card &&
      !primarySource?.details?.addressCountry
  );

  return {
    error: queryResults.error
      ? 'There was an issue loading your payment sources. Please try again'
      : null,
    forceSourceEdit,
    isLoading: queryResults.loading,
    paymentSources,
    primarySource,
    supportedPaymentMethods:
      queryResults?.data?.account?.supportedPaymentMethodsv2 ?? [],
  };
};

export default usePaymentSource;
